import { useEffect, useRef } from "react";
import {
  registerUnsavedChangesGuard,
  unregisterUnsavedChangesGuard,
} from "@/helpers/unsavedChangesGuard";

export function useUnsavedChangesGuard(
  isDirty: () => boolean,
  requestLeave: (onLeave: () => void) => void,
) {
  const guardRef = useRef({ isDirty, requestLeave });
  guardRef.current = { isDirty, requestLeave };

  useEffect(() => {
    const guard = {
      isDirty: () => guardRef.current.isDirty(),
      requestLeave: (onLeave: () => void) =>
        guardRef.current.requestLeave(onLeave),
    };
    registerUnsavedChangesGuard(guard);
    return () => unregisterUnsavedChangesGuard(guard);
  }, []);
}
